const routes = new Map();
let currentView = null;
let appRoot;

export function initRouter(root) {
  appRoot = root;
  window.addEventListener('popstate', () => render(location.pathname));
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-link]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('http')) return;
    e.preventDefault();
    navigate(href);
  });
}

export function route(path, handler) {
  routes.set(path, handler);
}

export async function navigate(path, { replace = false } = {}) {
  if (location.pathname === path) return;
  if (replace) history.replaceState(null, '', path);
  else history.pushState(null, '', path);
  await render(path);
}

export async function render(path) {
  if (typeof currentView?.cleanup === 'function') {
    try { currentView.cleanup(); } catch {}
  }
  currentView = null;

  const handler = matchRoute(path);
  appRoot.innerHTML = '';
  if (!handler) {
    appRoot.textContent = '404';
    return;
  }
  const view = await handler.fn({ root: appRoot, params: handler.params });
  currentView = view || null;
}

function matchRoute(path) {
  if (routes.has(path)) return { fn: routes.get(path), params: {} };
  for (const [pattern, fn] of routes) {
    if (!pattern.includes(':')) continue;
    const keys = [];
    const regex = new RegExp(
      '^' +
        pattern.replace(/:([^/]+)/g, (_, k) => {
          keys.push(k);
          return '([^/]+)';
        }) +
        '$'
    );
    const m = path.match(regex);
    if (m) {
      const params = {};
      keys.forEach((k, i) => (params[k] = m[i + 1]));
      return { fn, params };
    }
  }
  return null;
}
